import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LayoutAnonymous as Layout } from '../LayoutAnonymous';

const AnonymousRoutes = ({ component: Component, path }) => <Layout exact path={path} component={Component} />;

AnonymousRoutes.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
};

AnonymousRoutes.defaultProps = {};

export default connect()(AnonymousRoutes);
